module.exports = __webpack_public_path__ + "img/vatandas.960d370b.svg";